import React, { useState } from 'react'

import { Col, Row, HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useApplicationContext } from '../../../context/ApplicationContext'
import PaymentSolutions from './payment-solutions'
import SandboxPayments from './sandbox-payments'
import AppCredentials from './app-credentials'
import UpgradeAccount from './upgrade-account'
import LiveCredentialsFromClient from './live-credentials-from-client'
import CreateLiveApp from './create-live-app'
import Spinner from '../../../components/common/spinner'
import IntegrationGuide from './integration-guide'
import DoneTesting from './done-testing'
import FullAuthNeeded from '../../applications/sections/full-auth-needed'
import LiveNotAllowed from '../../applications/sections/live-not-allowed'

const BannerContent = ({
  accountType,
  bannerPage,
  isCredsForClient,
  setBannerPage,
  productIntegration,
  setIsCredsForClient,
  setProductIntegration,
}) => {
  const [tabIndex, setTabIndex] = useState(0)

  const {
    sandboxApps,
    liveApps,
    homePageDataLoading,
    setCurrentBannerStep,
    isWebLLSUser,
    feature_flag,
    liveApiAllowed,
  } = useApplicationContext()

  const sbApp =
    sandboxApps?.length > 0
      ? sandboxApps.find((e) => e.isSystemGenerated === true) || sandboxApps[0]
      : null
  const liveApp = liveApps?.length > 0 ? liveApps[0] : null

  // Helper functions for bannerPage 4
  const renderBannerPage4 = () => {
    if (feature_flag === 'Trmt_developer_feature_flag') {
      return null
    }

    if (isWebLLSUser && accountType === 'BUSINESS') {
      return (
        <>
          <BannerTitle />
          <FullAuthNeeded />
        </>
      )
    }

    if (liveApiAllowed === false && accountType === 'BUSINESS') {
      return (
        <>
          <BannerTitle />
          <LiveNotAllowed />
        </>
      )
    }

    if (!isWebLLSUser && isCredsForClient) {
      return (
        <LiveCredentialsFromClient setIsCredsForClient={setIsCredsForClient} />
      )
    }

    if (shouldShowBusinessCredentials()) {
      return renderBusinessCredentials()
    }

    if (!isCredsForClient && accountType !== 'BUSINESS') {
      return (
        <UpgradeAccount
          setBannerPage={setBannerPage}
          setIsCredsForClient={setIsCredsForClient}
        />
      )
    }

    return null
  }

  function shouldShowBusinessCredentials() {
    return !isWebLLSUser && !isCredsForClient && accountType === 'BUSINESS'
  }

  function renderBusinessCredentials() {
    if (!liveApp) {
      if (homePageDataLoading) {
        return <Spinner size="md" />
      }
      return <CreateLiveApp setBannerPage={setBannerPage} />
    }
    return (
      <AppCredentials setBannerPage={setBannerPage} app={liveApp} env="live" />
    )
  }

  // Helper for banner title
  const BannerTitle = () => (
    <Row>
      <Col xs={10} className="banner-title_row">
        <HeadingText size="sm">
          <Message id="onboarding-banner.livePaymentsTitle" />
        </HeadingText>
      </Col>
    </Row>
  )

  // Main render logic
  switch (bannerPage) {
    case 0:
      return (
        <PaymentSolutions
          setBannerPage={setBannerPage}
          setProductIntegration={setProductIntegration}
          tabIndex={tabIndex}
          setTabIndex={setTabIndex}
          setCurrentBannerStep={setCurrentBannerStep}
        />
      )
    case 1:
      return (
        <IntegrationGuide
          setBannerPage={setBannerPage}
          productIntegration={productIntegration}
        />
      )
    case 2:
      return (
        <AppCredentials
          setBannerPage={setBannerPage}
          app={sbApp}
          env="sandbox"
        />
      )
    case 3:
      return <SandboxPayments setBannerPage={setBannerPage} />
    case 4:
      return renderBannerPage4()
    case 5:
      return <DoneTesting />
    default:
      return <></>
  }
}

export default BannerContent
